export const audioPlayerStyles = `
.qbx-root {
  display: flex;
  flex-direction: column;
  row-gap: 0.75rem;
  padding: 1rem;
  background-color: var(--catchup-blue-50);
  border-radius: var(--rad-catchup-xlarge);
}

.qbx-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 0.75rem;
}

.qbx-play-btn {
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  background-color: var(--catchup-blue-500);
  transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1);
}

.qbx-play-btn:hover {
  background-color: var(--catchup-blue-600);
}

.qbx-rate-btn {
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  background-color: var(--catchup-gray-100);
  color: var(--catchup-dark-500);
  transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1);
  font-size: var(--fs-xs);
  font-weight: 600;
}

.qbx-rate-btn:hover {
  background-color: var(--catchup-gray-200);
}

.qbx-slider-wrap {
  flex: 1 1 0%;
  display: flex;
  flex-direction: column;
  row-gap: 0.25rem;
}

.qbx-slider {
  width: 100%;
  height: 0.5rem;
  background-color: var(--catchup-gray-200);
  border-radius: 0.5rem;
  appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
  accent-color: var(--catchup-blue-500);
}

.qbx-time-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: var(--fs-md);
  color: var(--catchup-gray-400);
}

.qbx-nav {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  column-gap: 1rem;
}

.qbx-nav-btn {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  border-radius: var(--rad-catchup-xlarge);
  border-width: 1px;
  border-style: solid;
  border-color: var(--catchup-gray-100);
  transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1);
}

.qbx-nav-btn:hover {
  border-color: var(--catchup-blue-500);
}

.qbx-nav-btn:disabled {
  opacity: 0.3;
}

.qbx-counter {
  font-size: var(--fs-md);
  color: var(--catchup-gray-400);
}
`;
